module.exports = __webpack_public_path__ + "img/m8.ac55f561.png";